$(document).ready(function () {

  // Bigfolio

  let select_products = [];
  let selected_base_product = {};
  let selected_base_price = document.querySelector('.mnm--selected-bar--price');
  let selected_base_title = document.querySelector('[mnm-sel-base--title]');
  let selected_ings_list = document.querySelector('[mnm-sel-ings] .mnm--ings-selector ul');
  let selected_add_to_cart = document.querySelector('[mnm--add-to-cart]');
  let selected_count = document.querySelector('.mnm--ings-selector span');
  let learn_more_trigger = document.querySelectorAll('.bf_choose_ingredient_learn, .bf_select_learn_btn');
  let learn_more_close = document.querySelectorAll('[close-learn-more]');

  console.log(learn_more_trigger, learn_more_close)

  //         Select Mix n mask Base product

  learn_more_trigger.forEach(function(item) {
    item.addEventListener('click', function() {
      console.log()
      this.closest('.bf_main_product_inner').querySelector('.bf_learn_more_popup').classList.add('open')
    })
  })

  learn_more_close.forEach(function(item) {
    item.addEventListener('click', function() {
      console.log()
      this.closest('.bf_learn_more_popup').classList.remove('open')
    })

    item.closest('.bf_learn_more_popup').addEventListener('click', function(e, el) {
      let innerEl = this.querySelector('.bf_learn_more_popup--inner')
      console.log(e.target.tagName, innerEl, this, e);
      
      if (innerEl !== e.target && !innerEl.contains(e.target))
      {
        console.log('Close on click outside');
        this.closest('.bf_learn_more_popup').classList.remove('open')
      }
    })
  })

  $(".bf_select_product_btn").click(function (e) {
    e.preventDefault();
    $('.bf_main_product_inner_1').removeClass('bf_selected_product');
    $(this).parents('.bf_main_product_inner_1').addClass('bf_selected_product');

    let getVarID = $(this).attr('data-variant-id');
    let getProPrice = $(this).attr('data-product-price');
    let getTitle = $(this).attr('data-product-title');

    console.log(getVarID);
    selected_base_product = {
      variant_id: parseInt(getVarID),
      price: getProPrice,
      title: getTitle,
    };

    selected_base_price.innerHTML = getProPrice
    selected_base_title.textContent = getTitle
    console.log('add base', selected_base_product);

    //           	createPayload()
  });

  //         unSelect mix n mask base product
  $(".bf_selected_btn").click(function (e) {
    e.preventDefault();
    $(this).parents('.bf_main_product_inner_1').removeClass('bf_selected_product');
    selected_base_product = "";
    selected_base_price.textContent = "$0.00";
    selected_base_title.textContent = "No Selected";
    console.log('Remove Base', selected_base_product)
  });

  //         Select Mix n Mask ingredients
  $(".bf_select_product:not(.not-available)").click(function (e) {
    e.preventDefault();
    if (select_products.length < 6)
    {
      $(this).parents('.bf_main_product_inner_img').addClass('bf_selected_prod');
    }

    let getVarID = $(this).attr('data-variant-id');
    let getTitle = $(this).attr('data-ings-title');

    console.log('select variant ID',getVarID)
    handleIngredients(getVarID, getTitle);
  });

  //         Unselect Mix n Mask INGREDIENTS
  $(".bf_additives_selected").click(function (e) {
    e.preventDefault();
    $(this).parents('.bf_main_product_inner_img').removeClass('bf_selected_prod');
    let getVarID = $(this).attr('data-variant-id')
    handleIngredients(getVarID)
  });

  selected_add_to_cart.addEventListener('click', function() {
    console.log('Add to cart');
    //     debugger;
    if(Object.keys(selected_base_product).length && select_products.length )
    {

      createPayload();
    }
    else
    {
      if (Object.keys(selected_base_product).length === 0 && select_products.length === 0)
      {
        alert('Select base product and ingredients')
      }
      else if (Object.keys(selected_base_product).length === 0)
      {
        alert('Please select base product')
      }

      else if (select_products.length === 0)
      {
        alert('Select at least 1 ingredient');
      }
    }
  })

  function handleIngredients(getVarID, getIngsTitle) {

    let varID = getVarID;

    console.log("Create Payload")
    //           	console.log('Random Number', random_number)

    if (containsObject(varID,select_products))
    { 
      console.log('Exist in Selected Array')

      let filteredPayload = select_products.filter(function(el) { return el.variant_id !== parseInt(varID) }); 

      console.log('filteredPayload----------------',filteredPayload);
      select_products = filteredPayload;

    }
    else
    {
      if (select_products.length < 6)
      {
        console.log('Not Exist in Selectex Array')
        select_products.push({
          variant_id: parseInt(varID),
          ings_title: getIngsTitle
        })
        //                 alert('less then 6')
      }
      else
      {
        alert('you can not add more then 6')
      }

    }
    console.log('------------------', select_products) 

    let temp_ings_list = "";
    select_products.forEach(function(item) {

      temp_ings_list += `<li><p>${ item.ings_title  }</p><button type="button" removeIngs data-variant-id="${ item.variant_id }"><svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M6 18L18 6M6 6l12 12"></path></svg></button></li>`
    })

    selected_ings_list.innerHTML = temp_ings_list
    selected_count.textContent = select_products.length;

  }

  $(document).on('click', '[removeIngs]', function() {

    let getID = parseInt($(this).attr('data-variant-id'));

    handleIngredients(getID);
    $(".bf_select_product:not(.not-available)").each(function() {
      //             debugger;
      let tempTarger = parseInt($(this).attr('data-variant-id'));

      if (getID === tempTarger)
      {
        $(this).closest('.bf_main_product_inner_img').removeClass('bf_selected_prod');
      }
    })
  })

  async function createPayload() {
    console.log('Payload Function')  
    let random_number = parseInt(Math.random() * (100 - 1) + 1);

    let child_product_ids = select_products.map(item => item.variant_id)
    console.log('Child_product', child_product_ids)

    let base_product_data = {
      id: selected_base_product.variant_id,
      quantity: 1,
      properties: {
        "_products": `{ ${ child_product_ids.join() } }`,
        "_type": "master",
        "_bid": `bid_${ random_number }`
      }
    }

    let ings_product_data = select_products.map(item => (
      {
        id: item.variant_id,
        quantity: 1,
        properties: {
          "_products": `{ ${ child_product_ids.join() } }`,
          "_type": "child",
          "_bid": `bid_${ random_number }`
        }
      }
    ))

    ings_product_data.push(base_product_data)


    console.log(ings_product_data);

    let bodyData = {
      items: ings_product_data
    }
    //     debugger;

    selected_add_to_cart.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="spin-animation" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
<path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
</svg>`
    selected_add_to_cart.disabled = true

    try
    {
      const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(bodyData)
      })

      const data = await response.json()

      selected_add_to_cart.textContent = 'Add to Cart';
      selected_add_to_cart.disabled = false;
      let sectionID = "mini-cart"

      const sectionResponse = await fetch(window.Shopify.routes.root + `?sections=${ sectionID }`)

      const sectionData = await sectionResponse.json();

      console.log('Section Data', sectionData)



      if (response.ok) {
        //         this.dispatchEvent(new CustomEvent("variant:added", {
        //           bubbles: true,
        //           detail: {
        //             variant: data.hasOwnProperty("items") ? data["items"][0] : data
        //           }
        //         }));
        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                                                                 const cartContent = await response2.json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));
          // [BFF DEV]
        cartContent["sections"] = sectionData;
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart: window.themeVariables.settings.cartType === "drawer"
            // openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
          }
        }));

        document.querySelector('#mini-cart').setAttribute('open', 'open');
      });
    }
    //       this.dispatchEvent(new CustomEvent("cart-notification:show", {
    //         bubbles: true,
    //         cancelable: true,
    //         detail: {
    //           status: response.ok ? "success" : "error",
    //           error: data["description"] || ""
    //         }
    //       }));


    console.log('data', data)
  }
  catch (error) {
    console.error('Mix in Mask', error);
  }


  //     .then(response => response.json())
  //     .then(data => {
  //       console.log("Mix in Mask Response", data.json(), data.status);

  //       selected_add_to_cart.textContent = 'Add to Cart',
  //         selected_add_to_cart.disabled = false;



  //       
  //     })
  //     .catch(error => {
  //       console.error('Mix in Mask', error);
  //       console.log("Mix in Mask Response", data);
  //       selected_add_to_cart.textContent = 'Add to Cart',
  //         selected_add_to_cart.disabled = false;
  //     })

}

                  function containsObject(string, list) {
  var i;
  for (i = 0; i < list.length; i++) {
    if (list[i].variant_id === parseInt(string)) {
      return true;
    }
  }
  return false;
};
});